import { MINUTES_IN_A_DAY } from '~/lib/DateTime';
import { clientFormatDateLong, clientFormatTime } from '~/public/lib/ClientDateTime.js';

const SeriesTime = ({ start, duration, clientTz }) => {
    const isDailyDuration = duration > 0 && duration % MINUTES_IN_A_DAY === 0;

    return (
        <div>
            {clientFormatDateLong(start, clientTz)}
            {!isDailyDuration && (
                <>
                    &nbsp; &middot; &nbsp;
                    <span className="text-gray-500">
                        {clientFormatTime(start, clientTz)}
                    </span>
                </>
            )}
        </div>
    );
};

export default SeriesTime;
